import React from 'react';
import { Main } from './components';

const OrdersWithoutWeight = () => <Main />;

export default OrdersWithoutWeight;

